import { render, staticRenderFns } from "./DasherTeamPending.vue?vue&type=template&id=2b76eda5&scoped=true"
import script from "./DasherTeamPending.vue?vue&type=script&lang=js"
export * from "./DasherTeamPending.vue?vue&type=script&lang=js"
import style0 from "./DasherTeamPending.vue?vue&type=style&index=0&id=2b76eda5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b76eda5",
  null
  
)

export default component.exports